// extracted by mini-css-extract-plugin
export var actions = "_mf-g";
export var benefitCard = "_mf-b";
export var benefitIcon = "_mf-d";
export var benefitLabel = "_mf-f";
export var benefits = "_mf-a";
export var benefitsSection = "_mf-8";
export var bodyText = "_mf-7";
export var closeButton = "_mf-2";
export var content = "_mf-3";
export var eyebrow = "_mf-4";
export var heading = "_mf-5";
export var image = "_mf-i";
export var imagePanel = "_mf-h";
export var modal = "_mf-0";
export var offerCard = "_mf-c";
export var offerIcon = "_mf-e";
export var sectionLabel = "_mf-9";
export var shell = "_mf-1";
export var title = "_mf-6";